import {useSelector} from "react-redux";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {elevation} from "@pg-design/elevation";
import {backgroundColor, borderRadius, calculateRemSize, flex, flexDirection, p, position} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {IRPStore} from "../../../../app/rp_reducer";
import {createOfferLink, OFFER_DETAIL_ALLOW_SHOW_SOLD_STAGE_PARAM} from "../../../helpers/create_offer_link";
import {getOfferStageText} from "../../../helpers/get_offer_stage_text";
import {IOfferGroups, IOfferStage, IOfferStageStatus} from "../../types/IOfferGroups";
import {OfferStageStatus} from "./OfferStageStatus";

interface IProps {
    className?: string;
    stage: IOfferStage;
    groups: IOfferGroups | null;
}

export const OfferDetailStage = (props: IProps) => {
    const {stage} = props;
    const isSold = stage.status === IOfferStageStatus.SOLD;

    const offer = useSelector((store: IRPStore) => store.offerDetail.offer);

    if (!offer) {
        return null;
    }

    const link = createOfferLink(
        {
            id: stage.offer.id,
            slug: stage.offer.slug,
            vendor: stage.offer.vendor,
            groups: props.groups
        },
        {
            ...(isSold
                ? {
                      [OFFER_DETAIL_ALLOW_SHOW_SOLD_STAGE_PARAM]: true
                  }
                : {})
        }
    );

    return (
        <StageWrapper css={props.className} href={link} disabled={stage.offer.id === offer?.id} target="_blank">
            <div css={container}>
                <Text variant="button_medium">{stage.name}</Text>
                <Text variant="info_txt_2">{getOfferStageText(stage.status)}</Text>
            </div>
            <OfferStageStatus status={stage.status} />
        </StageWrapper>
    );
};

interface IStageWrapperProps {
    disabled: boolean;
}

export const StageWrapper = styled.a<IStageWrapperProps>`
    ${position("relative")};
    ${flex("center", "space-between")};
    ${borderRadius(1)};
    background-color: #fff;
    border: 1px solid ${(props) => props.theme.colors.secondary};
    ${p(1, 2)};
    cursor: pointer;
    min-width: 160px;
    height: ${calculateRemSize(7)};
    flex-shrink: 0;

    :hover {
        ${elevation(1)};
    }

    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        min-width: initial;
        align-self: stretch;
        height: initial;
        flex-shrink: initial;
    }

    @media (min-width: ${(props) => props.theme.breakpoints.lg}) {
        min-width: 160px;
        align-self: normal;
        height: ${calculateRemSize(7)};
    }

    ${(props) =>
        props.disabled &&
        css`
            ${backgroundColor(props.theme.colors.background[200])};
            cursor: default;
            pointer-events: none;
        `}
`;

const container = (theme: Theme) => css`
    ${flex()};
    ${flexDirection("column")};

    * {
        color: ${theme.colors.secondary};
    }

    > * {
        white-space: nowrap;
    }

    @media (min-width: ${theme.breakpoints.md}) {
        > span {
            white-space: normal;
        }

        > p {
            white-space: nowrap;
        }
    }

    @media (min-width: ${theme.breakpoints.lg}) {
        > * {
            white-space: nowrap;
        }
    }
`;
import {useSelector} from "react-redux";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {elevation} from "@pg-design/elevation";
import {backgroundColor, borderRadius, calculateRemSize, flex, flexDirection, p, position} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {IRPStore} from "../../../../app/rp_reducer";
import {createOfferLink, OFFER_DETAIL_ALLOW_SHOW_SOLD_STAGE_PARAM} from "../../../helpers/create_offer_link";
import {getOfferStageText} from "../../../helpers/get_offer_stage_text";
import {IOfferGroups, IOfferStage, IOfferStageStatus} from "../../types/IOfferGroups";
import {OfferStageStatus} from "./OfferStageStatus";

interface IProps {
    className?: string;
    stage: IOfferStage;
    groups: IOfferGroups | null;
}

export const OfferDetailStage = (props: IProps) => {
    const {stage} = props;
    const isSold = stage.status === IOfferStageStatus.SOLD;

    const offer = useSelector((store: IRPStore) => store.offerDetail.offer);

    if (!offer) {
        return null;
    }

    const link = createOfferLink(
        {
            id: stage.offer.id,
            slug: stage.offer.slug,
            vendor: stage.offer.vendor,
            groups: props.groups
        },
        {
            ...(isSold
                ? {
                      [OFFER_DETAIL_ALLOW_SHOW_SOLD_STAGE_PARAM]: true
                  }
                : {})
        }
    );

    return (
        <StageWrapper css={props.className} href={link} disabled={stage.offer.id === offer?.id} target="_blank">
            <div css={container}>
                <Text variant="button_medium">{stage.name}</Text>
                <Text variant="info_txt_2">{getOfferStageText(stage.status)}</Text>
            </div>
            <OfferStageStatus status={stage.status} />
        </StageWrapper>
    );
};

interface IStageWrapperProps {
    disabled: boolean;
}

export const StageWrapper = styled.a<IStageWrapperProps>`
    ${position("relative")};
    ${flex("center", "space-between")};
    ${borderRadius(1)};
    background-color: #fff;
    border: 1px solid ${(props) => props.theme.colors.secondary};
    ${p(1, 2)};
    cursor: pointer;
    min-width: 160px;
    height: ${calculateRemSize(7)};
    flex-shrink: 0;

    :hover {
        ${elevation(1)};
    }

    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        min-width: initial;
        align-self: stretch;
        height: initial;
        flex-shrink: initial;
    }

    @media (min-width: ${(props) => props.theme.breakpoints.lg}) {
        min-width: 160px;
        align-self: normal;
        height: ${calculateRemSize(7)};
    }

    ${(props) =>
        props.disabled &&
        css`
            ${backgroundColor(props.theme.colors.background[200])};
            cursor: default;
            pointer-events: none;
        `}
`;

const container = (theme: Theme) => css`
    ${flex()};
    ${flexDirection("column")};

    * {
        color: ${theme.colors.secondary};
    }

    > * {
        white-space: nowrap;
    }

    @media (min-width: ${theme.breakpoints.md}) {
        > span {
            white-space: normal;
        }

        > p {
            white-space: nowrap;
        }
    }

    @media (min-width: ${theme.breakpoints.lg}) {
        > * {
            white-space: nowrap;
        }
    }
`;
